import React, { useState } from 'react';
import { paymentAPI } from '../services/api';
import './PaymentButton.css';

const PaymentButton = ({ projectId, purchaseType, amount, buttonText, onSuccess }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handlePayment = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await paymentAPI.createCheckoutSession(projectId, purchaseType);

      // Redirect to Stripe Checkout
      window.location.href = response.data.checkoutUrl;
    } catch (err) {
      console.error('Payment error:', err);
      setError(err.response?.data?.message || 'Failed to initiate payment. Please try again.');
      setLoading(false);
    }
  };

  return (
    <div className="payment-button-container">
      {error && (
        <div className="alert alert-error mb-2">
          {error}
        </div>
      )}

      <button
        className="btn btn-primary btn-lg payment-button"
        onClick={handlePayment}
        disabled={loading}
      >
        {loading ? (
          <>
            <span className="spinner-small"></span>
            Redirecting to Stripe...
          </>
        ) : (
          <>
            💳 {buttonText || `Pay $${amount} & Download`}
          </>
        )}
      </button>

      <p className="payment-note">
        <small>
          Secure payment via Stripe • 1-year access • Unlimited downloads
        </small>
      </p>
    </div>
  );
};

export default PaymentButton;
